// import { toast } from 'react-toastify';
// import axiosInstance from '../../config';

// export const executeAlertDataService = async (data, token) => {
//     try {
//         const response = await axiosInstance.post(
//             `/v2/sendAlert/${token}`,
//             data,
//             {
//                 headers: {
//                     Authorization: `Bearer ${token}`
//                 }
//             }
//         );

     
//         return {
//             success: true,
//             data: response.data,
//             status: response.status,
//         };

        
//     } catch (error) {
       
// //  console.log("exc data", error?.response.data)

//              toast.error(error?.response.data?.data)
//         return {
//             success: false,
            
//             message: error.response?.data?.message || "Alert Send failed",
//             status: error.response?.status || 500,
//             errors: error.response?.data?.data || null,
//         };
//     }
// };







import { toast } from 'react-toastify';
import axios from 'axios';

// ✅ FIXED - Remove axiosInstance, use direct axios
export const executeAlertDataService = async (data, secKey) => {
    console.log("🚀 Sending API request");
    console.log("🔑 Security key:", secKey ? secKey.substring(0, 15) + "..." : "MISSING");
    console.log("📦 Data:", JSON.stringify(data, null, 2));
    
    // ✅ FIXED - Only token in URL, NO Authorization header
    const url = `https://api.algocontroller.com/v2/sendAlert/${secKey}`;
    
    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            timeout: 30000
        });
        
        console.log("✅ API Success:", response.data);
        
        return {
            success: true,
            data: response.data,
            status: response.status,
        };
        
    } catch (error) {
        console.error("❌ API Error:", error.response?.data);
        
        const errorMessage = error.response?.data?.data || 
                            error.response?.data?.message || 
                            error.message || 
                            "Request failed";
        
        if (error.response?.status !== 401) {
            toast.error(errorMessage);
        }
        
        return {
            success: false,
            message: errorMessage,
            status: error.response?.status || 500,
            data: error.response?.data || null,
        };
    }
}; 